import { useTranslations } from "../../hooks/useTranslations";

export function PoweredByBadge() {
  const t = useTranslations();

  return (
    <a
      href="https://festapp.io"
      target="_blank"
      rel="noopener noreferrer"
      className="festapp-powered-by"
    >
      <span className="festapp-powered-by-text">{t.poweredBy}</span>
      <svg
        className="festapp-powered-by-logo"
        width="24"
        height="24"
        viewBox="0 0 313 313"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M0.25 312.737H32.6355C36.698 312.737 63.948 314.601 88.6875 273.708C113.427 232.815 140.667 234.669 144.729 234.669H312.75V156.497H205.302C201.24 156.497 173.99 154.633 149.25 195.526C124.51 236.419 97.271 234.555 93.2085 234.555H0.25V312.737Z"
          fill="url(#festapp-gradient-bottom)"
        />
        <path
          d="M312.75 0.26302H280.375C276.313 0.26302 249.052 -1.60144 224.323 39.2917C199.594 80.1849 172.333 78.3205 168.271 78.3205H0.25V156.441L107.729 156.503C111.792 156.503 139.052 158.368 163.781 117.474C188.51 76.581 215.74 78.383 219.802 78.383H312.75V0.26302Z"
          fill="url(#festapp-gradient-top)"
        />
        <defs>
          <radialGradient
            id="festapp-gradient-bottom"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(-93.3329 339.282) rotate(-26.9166) scale(490.561 396.076)"
          >
            <stop offset="0.119501" stopColor="#CA1800" />
            <stop offset="0.579966" stopColor="#F85040" />
            <stop offset="1" stopColor="#FF8D53" stopOpacity="0.9" />
          </radialGradient>
          <radialGradient
            id="festapp-gradient-top"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(-93.333 183.048) rotate(-26.9166) scale(490.561 396.076)"
          >
            <stop offset="0.119501" stopColor="#CA1800" />
            <stop offset="0.579966" stopColor="#F85040" />
            <stop offset="1" stopColor="#FF8D53" stopOpacity="0.9" />
          </radialGradient>
        </defs>
      </svg>
      <span className="festapp-powered-by-name">FEST App</span>
    </a>
  );
}
